import { AnalyticsMiddleware } from './analytics-middleware';
import { TestModeMiddleware } from '../../global/test-mode/test-mode-middleware';

export const CustomMiddleware = [AnalyticsMiddleware, TestModeMiddleware];
